import React from 'react';
import { Spinner } from '../../components/ui';
import EventForm from './EventForm';

// Desktop Events UI — a table as wide as its columns. Add/Edit/Del are
// Super-Admin only (vm.can). Click a row → its functions.
export default function EventsDesktop({ vm }) {
  const { filtered, loading, columns, can, q, setQ, startAdd, startEdit, del } = vm;
  const showActions = can.edit || can.delete;
  return (
    <div>
      <div className="page-head">
        <h1>Events</h1>
        <span className="count-pill">{filtered.length}</span>
        <div className="spacer" />
        <input className="ev-search" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Event</button>}
      </div>

      <div className="card table-wrap">
        {loading ? <Spinner /> : filtered.length === 0 ? (
          <div className="empty">No events yet.{!can.add && ' Ask an Admin to create one.'}</div>
        ) : (
          <table className="tbl ev-events-tbl">
            <thead>
              <tr>
                {columns.map(c => <th key={c.key}>{c.label}</th>)}
                {showActions && <th></th>}
              </tr>
            </thead>
            <tbody>
              {filtered.map(row => (
                <tr key={row.EventId} className="row-link" title="Open functions of this event" onClick={() => vm.openRow(row)}>
                  {columns.map(c => (
                    <td key={c.key}>{c.key === 'EventName'
                      ? <strong>{row.EventName ?? '—'}</strong>
                      : (c.render ? c.render(row) : (row[c.key] ?? '—'))}</td>
                  ))}
                  {showActions && (
                    <td className="ev-actions" onClick={(e) => e.stopPropagation()}>
                      {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                      {can.delete && <button className="btn danger sm" onClick={() => del(row)}>Del</button>}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <EventForm vm={vm} />
    </div>
  );
}
